import React from 'react';
import { motion } from 'framer-motion';
import { AuthForm } from './AuthForm';
import { AuthView } from './types';

interface AuthFormCardProps {
  view?: AuthView;
}

export const AuthFormCard = ({ view = 'sign_in' }: AuthFormCardProps) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="w-full max-w-xs sm:max-w-sm md:max-w-md relative"
    >
      {/* Decorative background elements */}
      <div className="absolute -z-10 -top-10 -right-10 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute -z-10 -bottom-10 -left-10 w-40 h-40 bg-indigo-500/10 rounded-full blur-3xl"></div>
      
      {/* Main card */}
      <div className="backdrop-blur-sm bg-gray-900/70 border border-gray-800 shadow-xl rounded-xl overflow-hidden">
        <AuthForm view={view} />
      </div>
    </motion.div>
  );
};

export default AuthFormCard;
